import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBTrtlav9GvIovbeeVqZK8TZ9fPDeWp4-g",
  authDomain: "app-lehongthai-vip.firebaseapp.com",
  projectId: "app-lehongthai-vip",
  storageBucket: "app-lehongthai-vip.firebasestorage.app",
  messagingSenderId: "86771692144",
  appId: "1:86771692144:web:c94ad4c54cb4d6756dfab5",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();